import { getEmailCharsFromStr } from '../text/get-email-chars-from-str';

import { TValidatorValue } from './models';
import { composeValidators, validate } from './utils';
import { validateNotEmpty } from './not-empty';

const DEFAULT_EMAIL_MESSAGE = 'Email введен некорректно. Пример: example@domain.ru';

/**
 * Валидирует строку с Email
 */
export const isValidEmail = (value?: string): boolean => {
    const cleanValue = getEmailCharsFromStr(value);
    const regexp = /^[\da-z]+(?:[._-][\da-z]+)*@[\da-z]{2,}(?:[._-][\da-z]+)*\.[a-z]{2,10}$/i;

    return regexp.test(cleanValue);
};

const validateEmailValue = (customMessage?: string) => (value: TValidatorValue) =>
    validate(isValidEmail(value), DEFAULT_EMAIL_MESSAGE, customMessage);

export const validateEmail = (message?: string) =>
    composeValidators(validateNotEmpty(), validateEmailValue(message));
